export default __webpack_public_path__ + "static/media/premium.46a842c1.svg";